import { render, staticRenderFns } from "./Niif.vue?vue&type=template&id=761a5e2f"
import script from "./Niif.vue?vue&type=script&lang=js"
export * from "./Niif.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports